import './Header.css';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/logo_edunexus.png';
import Button from '../../../../components/Button/Button';
import { ButtonProps } from '../../../../types';
import { useEffect } from 'react';
import { useAuth } from '../../../../contexts/AuthContext';

function Header() {
    const { user } = useAuth();
    const isAuth = !!user;

    const hamburguerProps: ButtonProps = {
        id: "mobile-menu-button",
        name: "☰",
        type: "button",
        props: {
            popoverTarget: "mobile-menu",
            className: "mobile-menu-button"
        }
    }

    const handleHashClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        const href = event.currentTarget.getAttribute('href') || '';
        const id = href.startsWith('#') ? href.slice(1) : href;
        const element = document.getElementById(id);

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            window.history.replaceState(null, '', `#${id}`);
        } else {
            window.location.hash = `#${id}`;
        }
    }

    const headerLinks = [
        { id: "home", name: "Home" },
        { id: "available-tools", name: "Tools" },
        { id: "popular-courses", name: "Courses" },
        { id: "about-us", name: "About Us" },
        { id: "contact", name: "Contact" },
    ];

    useEffect(() => {
        let lastScroll = 0;
        const header = document.getElementById('header');

        const handleScroll = () => {
            const currentScroll = window.scrollY;

            if (currentScroll < 100) {
                header?.classList.remove('header-hidden');
                return;
            }

            if (currentScroll > lastScroll) {
                header?.classList.add('header-hidden');
            } else {
                header?.classList.remove('header-hidden');
            }

            lastScroll = currentScroll;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header id="home-header">
            <nav className="container">
                <div className="logo">
                    <a 
                        href="#home" 
                        className="link" 
                        onClick={handleHashClick}
                    >
                        <img src={logo} alt="Logo" />
                    </a>
                </div>

                <div className="itens">
                    {headerLinks.map((link) => (
                        <a
                            key={link.id}
                            href={`#${link.id}`}
                            className="link"
                            onClick={handleHashClick}
                        >
                            {link.name}
                        </a>
                    ))}

                    {!isAuth && (
                        <Link to="/register" className="link">
                            <Button id="register" name="Register" />
                        </Link>
                    )}

                    {isAuth && (
                        <Link to="/dashboard" className="link">
                            <button
                                className="avatar mobile-menu-button"
                                id="mobile-menu-button"
                                popoverTarget="mobile-menu"
                            >
                                GV
                            </button>
                        </Link>
                    )}
                </div>
            </nav>

            <div className="mobile-menu-container">
                <div className="logo">
                    <a 
                        href="#home" 
                        className="link" 
                        onClick={handleHashClick}
                    >
                        <img src={logo} alt="Logo" />
                    </a>
                </div>

                <button
                    className="avatar mobile-menu-button"
                    id="mobile-menu-button"
                    popoverTarget="mobile-menu"
                >
                    GV
                </button>

                <dialog
                    popover="auto"
                    id={hamburguerProps.props.popoverTarget}
                    className="menu"
                >
                    {headerLinks.map((link) => (
                        <a
                            key={link.id}
                            href={`#${link.id}`}
                            className="link"
                            onClick={handleHashClick}
                        >
                            {link.name}
                        </a>
                    ))}

                    <hr className="divider" />

                    {!isAuth && (
                        <Link to="/register" className="link">
                            <Button id="register" name="Register" />
                        </Link>
                    )}

                    {isAuth && (
                        <Link to="/dashboard" className="link">
                            <Button id="dashboard" name="Dashboard" />
                        </Link>
                    )}
                </dialog>
            </div>
        </header>
    );
}

export default Header;